import {Injectable} from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';

@Injectable({
  providedIn: 'root',
})
export class ProfilsDroitsNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  edition = this.makeNavigatorWithParam<number>(EparcoursPath.root.PROFILS_DROITS, EparcoursPath.profilsDroits.EDITION);

  edition_copie = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PROFILS_DROITS,
    EparcoursPath.profilsDroits.EDITION,
    EparcoursPath.profilsDroits.COPIE,
  );

  creation = this.makeNavigator(EparcoursPath.root.PROFILS_DROITS, EparcoursPath.profilsDroits.CREATION);
}
